import { tns } from 'tiny-slider/src/tiny-slider';

export default class InvolvedCompaniesSlider {
  constructor(element) {
    this.houseItems = document.querySelectorAll('.house-types__slider-item');
    this.slider = tns({
      container: element.querySelector('.js-slider'),
      gutter: 18,
      fixedWidth: 280,
      edgePadding: 36,
      loop: false,
      center: false,
      nav: false,
      controlsContainer: element.querySelector('.js-slider-arrows'),
      responsive: {
        1025: {
          edgePadding: 56
        }
      }
    });
  }
}
